import type { ClipboardEvent, KeyboardEvent } from "react";
import { parsePhoneNumberFromString } from "libphonenumber-js/max";

export const PHONE_NUMBER_MAX_LENGTH = 15;

export function normalizePhoneDigits(value: string): string {
  return value.replace(/\D/g, "");
}

export function handlePhoneDigitKeyDown(
  event: KeyboardEvent<HTMLInputElement>,
): void {
  if (event.metaKey || event.ctrlKey || event.altKey) return;
  if (event.key.length === 1 && !/\d/.test(event.key)) {
    event.preventDefault();
  }
}

export function getPhoneDigitsAfterPaste(
  event: ClipboardEvent<HTMLInputElement>,
  maxLength = PHONE_NUMBER_MAX_LENGTH,
): string {
  event.preventDefault();
  const input = event.currentTarget;
  const pasted = normalizePhoneDigits(event.clipboardData.getData("text"));
  const start = input.selectionStart ?? input.value.length;
  const end = input.selectionEnd ?? input.value.length;
  return normalizePhoneDigits(
    `${input.value.slice(0, start)}${pasted}${input.value.slice(end)}`,
  ).slice(0, maxLength);
}

export function getPhoneNumberValidationError(value: string): string | null {
  const digits = normalizePhoneDigits(value);

  if (!digits) {
    return "Please enter a phone number with country code.";
  }

  const parsed = parsePhoneNumberFromString(`+${digits}`);

  if (!parsed?.countryCallingCode) {
    return "Please enter a valid phone number with country code (e.g. 919876543210).";
  }

  if (!parsed.isValid()) {
    return `This is not a valid phone number for +${parsed.countryCallingCode}. Check the country code and number.`;
  }

  return null;
}
